export default import.meta.ROLLDOWN_FILE_URL_B1JkMwpOujS5Kw4Qufl3ng